import {memo} from 'react';

import type {SVGProps} from 'react';

export const PrivacyPolicyIllustration = memo(function PrivacyPolicyIllustration(
  props: SVGProps<SVGSVGElement>
) {
  return (
    <svg
      width={48}
      height={48}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M41.4202 18.172L33.8972 10.591C33.5222 10.213 33.0112 10 32.4772 10H28.0002H16.9092C15.3032 10 14.0002 11.303 14.0002 12.909V43.09C14.0002 44.697 15.3032 46 16.9092 46H39.0902C40.6972 46 42.0002 44.697 42.0002 43.091V19.581C42.0002 19.053 41.7912 18.547 41.4202 18.172Z"
        fill="#8CE7F2"
      />
      <path
        d="M17.4998 22.5H30.4998"
        stroke="#18193F"
        strokeWidth={3}
        strokeMiterlimit={10}
        strokeLinecap="round"
      />
      <path
        d="M17.4998 29.5H26.4998"
        stroke="#18193F"
        strokeWidth={3}
        strokeMiterlimit={10}
        strokeLinecap="round"
      />
      <path
        d="M38.4998 23.085V14.5H31.4998C30.3998 14.5 29.4998 13.6 29.4998 12.5V5.5"
        stroke="#18193F"
        strokeWidth={3}
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M24.0002 5.5H12.5002C10.8002 5.5 9.50016 6.8 9.50016 8.5V39.5C9.50016 41.2 10.8002 42.5 12.5002 42.5H22.9152"
        stroke="#18193F"
        strokeWidth={3}
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M38.4998 14.5L29.4998 5.5"
        stroke="#18193F"
        strokeWidth={3}
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M45.1 39C45.4 38 45.5 37 45.5 36.2V32.2C45.5 31.5 45 31 44.4 30.9C41.9 30.6 39.8 29.3 38.8 28.6C38.4 28.3 37.8 28.3 37.3 28.6C36.3 29.3 34.2 30.6 31.7 30.9C31 31 30.6 31.5 30.6 32.2V36.2C30.6 38.8 31.7 43 37.6 45.7C37.9 45.8 38.3 45.8 38.7 45.7C40.2 45 41.4 44.2 42.4 43.4"
        stroke="#18193F"
        strokeWidth={3}
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
});
